import CollectorCard from "./CollectorCard";
import { Songcard } from "@/types";
import { Button, Center, Divider, Heading, Text } from "@chakra-ui/react";
import Link from "next/link";

interface HoldsProps {
  id: number;
  uuid: string;
  card: Songcard;
}
interface UserDataProps {
  userData: HoldsProps[];
}

const CollectorCards = ({ userData }: UserDataProps) => {
  return (
    <div>
      <Center>
        <Heading>Your Collection</Heading>
      </Center>
      <Center>
        <Text mt={5} mb={5}>
          Open your cards to unlock rewards
        </Text>
      </Center>
      <Center>
        <Divider maxW={300} mb={10} mt={5} />
      </Center>
      {userData.map((hold: { id: number; uuid: string; card: Songcard }) => (
        <div key={hold.id}>
          <div>
            <CollectorCard
              key={hold.id}
              card={hold.card}
              holdUUID={hold.uuid}
            />
            <br />
            <br />
          </div>
        </div>
      ))}
      {userData.length == 0 && (
        <>
          <Center mb={20}>
            <p>no cards found</p>
          </Center>
          <Center mt={5}>
            <Text as="b" mb={7}>
              Don{`'`}t have any Songcards yet?
            </Text>
          </Center>
          <Center>
            <Link href="/discover">
              <Button mb={10}>Start Browsing</Button>
            </Link>
          </Center>
        </>
      )}
    </div>
  );
};

export default CollectorCards;
